export default {
	propertymanagers: {
		footerText: {
			beforeLink: 'The',
			linkText: 'Aareon Deutschland GmbH',
			afterLink:
				'is the operator of this portal and acts on behalf of your {propertyManagersLabel}: As your property manager, ' +
				'we are responsible for this data processing. ' +
				'For this purpose, we use the platform provider Aareon Deutschland GmbH as our subcontractor.',
		},
		label: 'Property manager | Property managers',
		visibility: {
			title: 'Property Manager Visibility',
			description:
				'Control which property managers are visible to tenants and owners in the app. At least one property manager must remain visible.',
			column: {
				name: 'Name',
				address: 'Address',
				visible: 'Visible in app',
			},
			tooltip: {
				lastVisible:
					'At least one property manager must remain visible in the app.',
			},
			emptyState: 'No property managers found.',
			savingProgress: '{done} of {total} saved',
			savingInProgress:
				'Visibility is being saved. Please wait until all property managers have been updated.',
			loadError: 'Property managers could not be loaded.',
		},
	},
}
